
import React from "react";
import Chart from "react-apexcharts";

const SpendCategoryChart = ({ data = {}, type }) => {

    const labels = Object.keys(data);

    const series = Object.values(data);


    const options = {

        labels: labels,

        plotOptions: {
            pie: {
                donut: {
                    size: "60%",
                    labels: {
                        show: true,
                        total: {
                            show: true,
                            label: `${type} Spend`,
                            fontSize: "14px",
                            fontWeight: 600,
                            formatter: function (w) {
                                return w.globals.seriesTotals.reduce(
                                    (a, b) => a + b,
                                    0
                                );
                            }
                        }
                    }
                }
            }
        },

        grid: {
            padding: {
                top: 20,
                bottom: 20,
                left: 10,
                right: 10
            }
        },


        legend: {
            position: "right",
            fontSize: "14px",

            itemMargin: {
                vertical: 8
            },

            formatter: function (seriesName, opts) {

                const value =
                    opts.w.globals.series[opts.seriesIndex];

                return `${seriesName} - ${value}`;
            }
        },


        dataLabels: {

            enabled: true,

            style: {
                fontSize: "15px",
                fontWeight: 600,
                colors: ["#fff"]
            },


            formatter: function (value, opts) {

                return opts.w.globals.series[opts.seriesIndex];

            }
        },


        tooltip: {

            y: {

                formatter: function (value, opts) {

                    const total =
                        opts.globals.seriesTotals.reduce(
                            (a, b) => a + b,
                            0
                        );


                    const percentage =
                        ((value / total) * 100).toFixed(1);


                    return `${value} (${percentage}%)`;

                }

            }

        },


        colors: [
            "#2563EB",
            "#14B8A6",
            "#FDBA3B",
            "#8B5CF6",
            "#64748B"
        ],


        responsive: [
            {
                breakpoint: 768,
                options: {
                    legend: {
                        position: "bottom"
                    }
                }
            }
        ]

    };


    return (

        <Chart
            options={options}
            series={series}
            type="donut"
            height={320}
        />

    );

};


export default SpendCategoryChart;